import { Component, OnInit } from '@angular/core';
import { EnrollmentAppStateStructure } from 'src/app/angular-elements/shared/interfaces/enrollmentAppStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PrintButtonComponent } from '../../print-button.component';
import { PrintButtonService } from '../../services/print-button.service';

@Component({
    selector: 'app-populated-special-enrollment-form-print',
    templateUrl: './../../print-button.component.html',
    styleUrls: ['./../../print-button.component.scss'],
    standalone: false
})
export class PopulatedSpecialEnrollmentFormPrintComponent extends PrintButtonComponent implements OnInit {

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private printButtonService: PrintButtonService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

  }

  async onPrintPage(): Promise<void> {
    super.onPrintPage();
    
    const eApp = this.printButtonService.getEnrollmentAppInfo();

    await this.printButtonService.downloadSEPApplicationPDF(eApp.appId);
  }
}
